<template>
    <span :class="showMainClass()">
      <div class="changeable-prices">
        <reservation-price-input
          customStyle="color: #12b47d"
          @changeCustomPrice="this.changePaidPrice"
          :customPrice="this.paidPriceTotal"
          :hideWhenEmpty="false"
        ></reservation-price-input>&nbsp;/&nbsp;
        <reservation-price-input
          @changeCustomPrice="this.changeCustomPrice"
          :customPrice="this.customTotal"
          :hideWhenEmpty="true"
        ></reservation-price-input>
      </div>
      <div><span v-if="customPriceShowed" class="red-text">(<span>{{ totalPrice() }}</span>, {{ totalCustomPriceDifference() }})</span><span v-if="this.customTotal === 0">{{ totalPrice() }}</span></div>
    </span>
</template>

<script>
import {moneyFormat} from '@/mixins/moneyFormat'

export default {
  props: {
    price: {
      type: [String, Number],
      required: false
    },
    paidPrice: {
      type: [String, Number],
      required: false
    },
    customPrice: {
      type: [String, Number],
      required: false
    },
    insPrice: {
      type: [String, Number],
      required: false
    }
  },
  data () {
    return {
      total: this.price,
      customPriceShowed: this.customPrice && this.customPrice !== this.price,
      customTotal: parseFloat(this.customPrice),
      paidPriceTotal: parseFloat(this.paidPrice),
      customTotalPriceDifference: (this.customPrice - this.price)
    }
  },
  mixins: [moneyFormat],
  methods: {
    showMainClass () {
      return 'price ' + (!this.customPriceShowed ? 'no-flex' : '')
    },
    formatPrice (value) {
      let total = parseInt(value)
      return this.formatMoney(total, 'EUR')
    },
    totalPrice () {
      return this.formatPrice(this.total)
    },
    totalCustomPriceDifference () {
      if (this.customTotalPriceDifference < 0) {
        return '-€' + Math.abs(this.customTotalPriceDifference / 100)
      } else {
        return '+€' + (this.customTotalPriceDifference / 100)
      }
    },
    changeCustomPrice (value) {
      this.customTotal = value
      this.customTotalPriceDifference = (this.customTotal - this.total)
      this.$emit('changeCustomPrice', this.customTotal)
      this.customPriceShowed = this.customTotal && this.customTotal !== this.total
    },
    changePaidPrice (value) {
      this.paidPriceTotal = value
      this.$emit('changePaidPrice', this.paidPriceTotal)
    }
  }
}
</script>

<style>
.price > div.changeable-prices{
  display: flex;
  flex-wrap: nowrap;
  text-align: right;
}
.price.no-flex{
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/reservation/PriceTotal.vue